export default "__VITE_ASSET__CqvFX_0k__"